var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_html"},[_c('div',{staticClass:"title"},[_vm._v(" 网络安全教育培训平台 ")])])}]

export { render, staticRenderFns }